import { templateSectionConfig, sectionConfig } from "./droppable_config";
import { getMouseDownDateForSectionDraw, handleSectionMouseUp } from "./summary_dws_draw";
import { roundDateDownToNearest15MinIncrement } from "./common";

const HORIZONTAL_OFFSET = 5;
let sectionTemplate = null;

export function initTemplateSectionDrag(slotMap, roles) {
  const sectionContainer = document.getElementById('role-section-template-list');
  if (!sectionContainer) {
    return;
  }

  const draggable = new Draggable.default(sectionContainer, templateSectionConfig);

  // Store the selected template
  sectionContainer?.addEventListener('mousedown', (e) => {
    const el = e.target.closest('.template-slot-list-item.draggable');
    sectionTemplate = el;
  });

  draggable.on('drag:start', (evt) => handleTemplateDragStart(evt));
  draggable.on('drag:stop', () => handleTemplateDragStop(slotMap, roles));
}

function handleTemplateDragStart(evt) {
  const draggedSection = evt.source;

  // Select the section in the template
  if (sectionTemplate && !sectionTemplate.classList.contains('select')) {
    draggedSection.classList.add("select");
    selectTemplate(sectionTemplate);
  }
}

function handleTemplateDragStop(slotMap, roles) {
  const mirror = document.querySelector('.draggable-mirror');
  if (!mirror) {
    closeTemplateList();
    return;
  }

  // Find the drop target based on the mirror's position
  const rect = mirror.getBoundingClientRect();
  const dropTarget = document.elementFromPoint(rect.left, rect.top + rect.height / 2);

  if (!dropTarget || !dropTarget.classList.contains('draw-sections')) {
    closeTemplateList();
    return;
  }

  createSection(dropTarget, rect, slotMap, roles);
}


let sectionsDraggable;

// Drag and drop for existing sections inside slots
export function initSectionDrag(slotMap, roles) {
  const draggableSectionElements = Array.from(document.querySelectorAll('.section.draggable'));
  sectionsDraggable = new Draggable.default(draggableSectionElements, sectionConfig);

  sectionsDraggable.on('drag:start', (evt) => handleDragStart(evt));
  sectionsDraggable.on('drag:stop', (evt) => handleDragStop(evt, slotMap, roles));
}

function handleDragStart(evt) {
  const draggedSection = (evt.originalEvent?.target) || null;

  // Prevent drag if resizing section
  if (draggedSection && draggedSection.closest(".ui-resizable-handle")) {
    evt.cancel();
    return;
  }

  // Add drop target indicators
  document.querySelectorAll('.draw-sections').forEach(el => {
    el.classList.add('active')
  });
  document.querySelectorAll('.slot').forEach(el => {
    el.classList.add('draw-sections-active');
  });
}

async function handleDragStop(evt, slotMap, roles) {
  const sectionEl = evt.source;

  const mirror = document.querySelector('.draggable-mirror');
  if (!mirror) {
    cleanupAfterSectionDrag();
    return;
  }

  // Find the drop target based on the mirror's position
  const rect = mirror.getBoundingClientRect();
  const dropTarget = document.elementFromPoint(rect.left, rect.top + rect.height / 2);
  const sectionId = sectionEl.dataset.id;

  if (!(dropTarget?.classList?.contains('draw-sections')) || !sectionId) {
    cleanupAfterSectionDrag();
    return;
  }

  try {
    await createSection(dropTarget, rect, slotMap, roles, sectionId);
    removeSection(sectionId);

  } finally {
    cleanupAfterSectionDrag();
  }
}

function cleanupAfterSectionDrag() {
  document.querySelectorAll('.draw-sections').forEach(el => {
    el.classList.remove('active');
  });

  document.querySelectorAll('.slot').forEach(el => {
    el.classList.remove('draw-sections-active');
  });
}

export function initDroppableOnSection(slot) {
  if (!slot.Sections) {
    return;
  }

  slot.Sections.forEach(sectionId => {
    const newSectionEl = document.getElementById(`slot-${sectionId}`);
    if (newSectionEl) {
      sectionsDraggable.addContainer(newSectionEl);
    }
  })
}


export function createSection(dropTarget, rect, slotMap, roles, sectionId = 0) {
  if (!rect || !dropTarget) {
    return;
  }

  const dropTargetRect = dropTarget.getBoundingClientRect();

  // Offset horizontally to prevent near-boundary drops from snapping to the previous cell.
  const mouseDownEvent = {
    target: dropTarget,
    originalEvent: {
      layerX: rect.left - dropTargetRect.left + HORIZONTAL_OFFSET,
    },
    pageX: rect.left + HORIZONTAL_OFFSET,
    pageY: rect.top + rect.height / 2
  };

  const slotId = Number(dropTarget.dataset.slotId);
  const slot = slotMap[slotId];
  const section = slotMap[sectionId];
  return handleSectionDrawOnDrop(mouseDownEvent, slot, roles, section);
}

function handleSectionDrawOnDrop(event, slot, roles, section) {
  const drawSectionsEl = $(event.target);

  let role = {};
  if (section?.RoleID) {
    // Get existing role section that was dragged
    role = roles.find(r => r.ID === section.RoleID) || {};
  } else if (selectedTemplate?.id) {
    // Get selected role section from template
    role = roles.find(r => r.ID === selectedTemplate.id) || {};
  }

  const relativeLeft = event.originalEvent.layerX / drawSectionsEl.innerWidth();
  const fromDate = getMouseDownDateForSectionDraw(slot, relativeLeft);
  roundDateDownToNearest15MinIncrement(fromDate);

  let toDate;
  if (section) {
    // get difference between start and end time of section
    const d = (Number(section?.ToUnix) - Number(section?.FromUnix)) / 60;
    const differenceInMin = d > 0 ? Math.round(d) : 60;

    toDate = new Date(fromDate);
    toDate.setUTCHours(toDate.getUTCHours(), toDate.getUTCMinutes() + differenceInMin, 0, 0);
  }

  return handleSectionMouseUp(slot, role, fromDate, toDate, Boolean(selectedTemplate?.id), section);
}
